export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">关于我们</span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">关于51黑料网</h2>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-10 max-w-3xl mx-auto">
          <div className="space-y-4 text-sm text-foreground-700 leading-relaxed">
            <p>
              <strong className="text-foreground-900">51黑料网</strong>是国内领先的娱乐圈资讯聚合平台，致力于为吃瓜群众提供最新、最全、最真实的娱乐圈动态。我们全天候追踪网红、明星、综艺、影视等领域的第一手猛料，以独立视角为读者呈现娱乐圈的真实面貌。
            </p>
            <p>
              平台每日更新海量独家内容，覆盖网红聊天记录泄露、明星塌房内幕、影视综艺翻车实锤等热门话题。所有内容均来自公开渠道与可靠爆料人投稿，经编辑团队核实后发布，确保每一条黑料都有据可查。
            </p>
            <p>
              51黑料网始终坚持<strong className="text-foreground-900">免费开放</strong>原则，不设付费墙、不搞会员制，让每一位吃瓜群众都能零门槛获取娱乐圈最新资讯。我们相信，吃瓜是每个人的权利。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}